'use strict';

angular.module('basketModule')
.factory('basketListView', basketListView);

function basketListView ()
{
    return {
        label: 'list',
        buttonClass: 'btn',
        iconClass: 'material-icon material-icon-view-list',
        templateUrl: 'basket/basket.list.html'
    };
}
